module.exports = __webpack_public_path__ + "66ab3a570f8eaf923d8288c0272b5068.mp3";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/level_4_rustig.mp3
// module id = 77
// module chunks = 0